/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { FilterPresenterType } from '../components/presenters/types';

/**
 * Filter presenters types are specified for the given cell presenters type.
 */
export const filterPresenterConfig: { [key: string]: FilterPresenterType } = {
  Float: FilterPresenterType.DecimalNumber,

  Kind: FilterPresenterType.Dropdown,
  Means: FilterPresenterType.Dropdown,
  Status: FilterPresenterType.Dropdown,
  RiskRating: FilterPresenterType.Dropdown,
  Rating: FilterPresenterType.Dropdown,
  Tags: FilterPresenterType.Tags,

  // TODO: consolidate boolean presenters when GQL query changes allow for it
  Boolean: FilterPresenterType.Boolean,
  AuditType: FilterPresenterType.Boolean,
  Significance: FilterPresenterType.Boolean,
  Watching: FilterPresenterType.Boolean,
  //

  Default: FilterPresenterType.Text,
  RichText: FilterPresenterType.Text,
  Title: FilterPresenterType.Text,
  Attachments: FilterPresenterType.Text,
  SurveyResponseTitle: FilterPresenterType.Text,

  Date: FilterPresenterType.Date,
  // TODO: consider re-adding DateTime presenter when adding date range operator
  DateTime: FilterPresenterType.Date,
  EndDate: FilterPresenterType.Date,

  Link: FilterPresenterType.Text,

  MappedObjects: FilterPresenterType.MappedObjects,

  Object: FilterPresenterType.Object,
  ModifiedObject: FilterPresenterType.Text,
  MappingTo: FilterPresenterType.Text,
  MappingFrom: FilterPresenterType.Text,

  RelatedObjects: FilterPresenterType.Text,

  // TODO: groups will gradually replace all person relationship attributes
  //   and the People filter presenter type will be removed
  Group: FilterPresenterType.Groups,
  Person: FilterPresenterType.People,
  Reviewers: FilterPresenterType.People,

  Recurrence: FilterPresenterType.Recurrence,

  SurveyTemplateTitle: FilterPresenterType.Text,

  ObjectId: FilterPresenterType.Number,
};

export const customAttributeFilterPresenterConfig: { [key: string]: FilterPresenterType } = {
  TEXT: FilterPresenterType.Text,
  RICH_TEXT: FilterPresenterType.Text,
  DATE: FilterPresenterType.Date,
  INT: FilterPresenterType.Number,
  FLOAT: FilterPresenterType.DecimalNumber,
  CHECKBOX: FilterPresenterType.Boolean,
  DROPDOWN: FilterPresenterType.Dropdown,
  MULTI: FilterPresenterType.Dropdown,
  MAP_PERSON: FilterPresenterType.People,
};
